import React from 'react';

const CashOffChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M3.8 5.3l3.4 3.4c0 2.1 1.6 3.2 3.9 3.9l3.5 3.5c-.3.5-1 .9-2.4.9-2.1 0-2.9-.9-3-2.1H7.1c.1 2.2 1.8 3.4 3.7 3.8V21h2v-2.1c1-.2 2.8-.6 3.4-1.1l2.2 2.2 1.4-1.4L5.3 3.9zm11 3.7H17c-.1-1.7-2.1-3.3-4.1-3.8V3h-2v2.2c-.5.1-1.1.3-1.5.5l1.5 1.5c.4-.2.9-.3 1.5-.3 1.7 0 2.3.9 2.4 2.1z" />
    </svg>
);

CashOffChunkySvg.displayName = 'CashOffChunkySvg';
export default CashOffChunkySvg;
